/* Manitowoc hub — collection template v2. Picker, accordion, sticky bar, capture, GA4. */
(function(){
  'use strict';
  var root = document.querySelector('.hb-collection-v2');
  if (!root) return;

  /* Expose hub context for the global quote drawer (quote-drawer-v2.js reads
     window.hbQuoteContext on open), so hub-originated quote requests carry
     their source page — and, once the picker runs, the full picker answers. */
  window.hbQuoteContext = { page: location.pathname };

  var WEBPRICE_HTML = '<span class="hb-collection-v2-webprice">'
    + '<span class="hb-collection-v2-webprice-label">Web Price</span>'
    + '<button type="button" class="hb-collection-v2-webprice-q" aria-label="Why is this the Web Price?">?</button>'
    + '<span class="hb-collection-v2-webprice-tip" role="tooltip">'
    + '<span class="hb-collection-v2-webprice-tip-text">This is the manufacturer’s Minimum Advertised Price (MAP). Want a better price? Request a custom quote — our team can unlock exclusive pricing, volume discounts, and project rates reserved for direct requests. Free and no obligation.</span>'
    + '<button type="button" class="hb-collection-v2-webprice-tip-link" data-open-quote>Request an unadvertised deal ›</button>'
    + '</span></span>';

  function fireGA4Event(name, params){
    if (typeof gtag !== 'function') return;
    gtag('event', name, Object.assign({
      event_callback: function(){},
      event_timeout: 1000,
      transport_type: 'beacon'
    }, params || {}));
  }

  /* ---------- picker data (verified active handles; prices hydrate live below) ---------- */
  var CDN = 'https://cdn.shopify.com/s/files/1/0627/8725/6536/files/';
  var MODELS = [
    {m:'UDF0140A', series:'NEO', form:'dice', config:'undercounter', lbday:132, bin:90, width:'26"', volt:'115V', price:2699, handle:'manitowoc-udf0140a-neo-undercounter-ice-machine', img:CDN+'399-udf0140a161.jpg?v=1722989595'},
    {m:'UYP0240A', series:'NEO', form:'half', config:'undercounter', lbday:250, bin:90, width:'26"', volt:'115V', price:3369, handle:'manitowoc-neo-uyp0240a-250lb', img:CDN+'399-uyp0240a161b.jpg?v=1780462112'},
    {m:'UYP0310A', series:'NEO', form:'half', config:'undercounter', lbday:330, bin:119, width:'30"', volt:'115V', price:4100, handle:'manitowoc-neo-uyp0310a-330lb', img:CDN+'399-uyp0310a161b.jpg?v=1780462114'},
    {m:'UDP0310A', series:'NEO', form:'dice', config:'undercounter', lbday:315, bin:119, width:'30"', volt:'115V', price:4100, handle:'manitowoc-neo-udp0310a-315lb', img:CDN+'399-udp0310a161b.jpg?v=1780461856'},
    {m:'UNP0200A', series:'Nugget', form:'nugget', config:'undercounter', lbday:213, bin:20, width:'19"', volt:'115V', price:4818, handle:'manitowoc-unp0200a-213lb', img:CDN+'399-unp0200a.jpg?v=1780461966'},
    {m:'UNP0300A', series:'Nugget', form:'nugget', config:'undercounter', lbday:330, bin:50, width:'30"', volt:'115V', price:5537, handle:'manitowoc-unp0300a-330lb', img:CDN+'399-unp0300a.jpg?v=1780461967'},
    {m:'UFP0350A', series:'Flake', form:'flake', config:'undercounter', lbday:400, bin:60, width:'30"', volt:'115V', price:5250, handle:'manitowoc-ufp0350a-400lb', img:CDN+'399-ufp0350a.jpg?v=1780461857'},
    {m:'IDP0300A', series:'Indigo NXT', form:'dice', config:'head', lbday:309, bin:0, width:'30"', volt:'115V', price:3651, handle:'manitowoc-indigo-nxt-idp0300a-309lb', img:CDN+'399-idt0300a.jpg?v=1780456077'},
    {m:'IDP0450A', series:'Indigo NXT', form:'dice', config:'head', lbday:483, bin:0, width:'30"', volt:'115V', price:3945, handle:'manitowoc-indigo-nxt-idp0450a-483lb', img:CDN+'399-idt0450a161.jpg?v=1780456468'},
    {m:'IYP0420A', series:'Indigo NXT', form:'half', config:'head', lbday:436, bin:0, width:'22"', volt:'115V', price:4028, handle:'manitowoc-indigo-nxt-iyp0420a-436lb', img:CDN+'399-iyt0420a161.jpg?v=1780458646'},
    {m:'IDP0450A + D570', series:'Indigo NXT', form:'dice', config:'combo', lbday:483, bin:532, width:'30"', volt:'115V', price:5695, handle:'manitowoc-indigo-nxt-idp0450a-d570-483lb-full-cube-ice-machine-bin', img:CDN+'399-idt0450ad570_e8a40847-eeff-435e-85ab-7e2538bdb157.jpg?v=1780429826'},
    {m:'IYP0420A + D420', series:'Indigo NXT', form:'half', config:'combo', lbday:436, bin:383, width:'22"', volt:'115V', price:5620, handle:'manitowoc-indigo-nxt-iyp0420a-d420-436lb', img:CDN+'399-iyt0420ad420.jpg?v=1780458783'},
    {m:'IDT1200A + D970', series:'Indigo NXT', form:'dice', config:'combo', lbday:1196, bin:882, width:'48"', volt:'208-230V', price:10095, handle:'manitowoc-indigo-nxt-idt1200a-d970-k00470-1196lb', img:CDN+'399-idt1200ad970.jpg?v=1780457674'},
    {m:'CNP0201A', series:'Countertop', form:'nugget', config:'dispenser', lbday:315, bin:10, width:'16"', volt:'115V', price:5802, handle:'manitowoc-cnp0201a-315lb', img:CDN+'399-cnf0201a.jpg?v=1780455424'}
  ];

  /* hydrate live price/availability from Shopify so the picker never shows stale numbers */
  MODELS.forEach(function(md){
    fetch('/products/' + md.handle + '.js').then(function(r){ return r.ok ? r.json() : null; }).then(function(p){
      if (!p) return;
      md.price = Math.round(p.price / 100);
      md.available = p.available;
    }).catch(function(){});
  });

  var STEPS = [
    {q:'What kind of business is this for?', help:'Sets the sizing rule of thumb we use.', key:'biz', opts:[
      {v:'bar', t:'Bar / brewery taproom', d:'~3 lb of ice per seat'},
      {v:'restaurant', t:'Restaurant / café', d:'~1.5 lb per seat'},
      {v:'hotel', t:'Hotel / hospitality', d:'~5 lb per room'},
      {v:'healthcare', t:'Healthcare', d:'~10 lb per bed · nugget ice'},
      {v:'cstore', t:'C-store / office', d:'Dispenser-driven'}
    ]},
    {q:'How big is the operation?', help:'We convert this to pounds of ice per day.', key:'size', opts:[
      {v:50, t:'Under 50 seats / rooms', d:''},
      {v:100, t:'50–120', d:''},
      {v:200, t:'120–250', d:''},
      {v:350, t:'250+', d:''}
    ]},
    {q:'What ice form do you pour?', help:'Form drives the machine family.', key:'form', opts:[
      {v:'dice', t:'Full dice', d:'Spirits, soda, all-purpose'},
      {v:'half', t:'Half dice', d:'Fast cooling, packs a glass'},
      {v:'nugget', t:'Nugget', d:'Chewable — healthcare, sodas'},
      {v:'flake', t:'Flake', d:'Display, produce, seafood'}
    ]},
    {q:'What configuration fits the space?', help:'', key:'config', opts:[
      {v:'undercounter', t:'Undercounter', d:'Self-contained, slides under the bar'},
      {v:'head', t:'Machine head only', d:'I have / will pick a bin'},
      {v:'combo', t:'Machine + storage bin', d:'Complete floor unit'},
      {v:'dispenser', t:'Ice & water dispenser', d:'Self-serve or countertop'}
    ]},
    {q:'Power at the install point?', help:'Check the breaker panel — most machines under 500 lb/day run 115V.', key:'volt', opts:[
      {v:'115V', t:'115V standard outlet', d:''},
      {v:'208-230V', t:'208–230V', d:''},
      {v:'any', t:'Not sure yet', d:''}
    ]}
  ];

  var RATE = {bar:3, restaurant:1.5, hotel:5, healthcare:10, cstore:1};
  var state = {}, stepIdx = 0, started = false;
  function $(id){ return document.getElementById(id); }

  var stepsEl = $('picker-steps');
  if (stepsEl) {

    var renderStep = function(){
      var s = STEPS[stepIdx], prog = $('picker-progress'), html = '';
      for (var i = 0; i < STEPS.length; i++) html += '<span class="dot' + (i <= stepIdx ? ' done' : '') + '"></span>';
      html += '<span class="label">Step ' + (stepIdx + 1) + ' of ' + STEPS.length + '</span>';
      prog.innerHTML = html;
      $('picker-q').textContent = s.q;
      $('picker-help').textContent = s.help;
      var opts = '';
      s.opts.forEach(function(o, i){
        opts += '<button type="button" class="hb-collection-v2-picker-opt" data-i="' + i + '"><span class="t">' + o.t + '</span>' + (o.d ? '<span class="d">' + o.d + '</span>' : '') + '</button>';
      });
      $('picker-opts').innerHTML = opts;
      $('picker-back').hidden = stepIdx === 0;
      var calc = $('picker-calc');
      if (s.key === 'form' && state.lbday) {
        calc.innerHTML = 'Sized for <strong>≈ ' + state.lbday + ' lb of ice/day</strong> (busiest day + 20% headroom)';
        calc.classList.add('show');
      } else {
        calc.classList.remove('show');
      }
      $('picker-opts').querySelectorAll('button').forEach(function(btn){
        btn.addEventListener('click', function(){ pick(s, parseInt(btn.dataset.i, 10)); });
      });
    };

    var pick = function(s, i){
      var o = s.opts[i];
      if (!started) { started = true; fireGA4Event('picker_start'); }
      state[s.key] = o.v;
      if (s.key === 'size') { state.lbday = Math.round(o.v * (RATE[state.biz] || 1.5) * 1.2); }
      stepIdx++;
      fireGA4Event('picker_step_' + stepIdx);
      if (stepIdx >= STEPS.length) { showResults(); } else { renderStep(); }
    };

    var showResults = function(){
      var need = state.lbday || 200;
      var matches = MODELS.filter(function(md){
        if (state.form && md.form !== state.form) return false;
        if (state.config && md.config !== state.config) return false;
        if (state.volt && state.volt !== 'any' && md.volt !== state.volt) return false;
        return md.lbday >= need * 0.8;
      }).sort(function(a, b){ return a.lbday - b.lbday; }).slice(0, 3);
      if (!matches.length) {
        matches = MODELS.filter(function(md){ return md.form === state.form || md.config === state.config; })
          .sort(function(a, b){ return Math.abs(a.lbday - need) - Math.abs(b.lbday - need); }).slice(0, 3);
      }
      stepsEl.style.display = 'none';
      var r = $('picker-results');
      r.classList.add('show');
      $('picker-results-sub').textContent = 'Sized for ≈ ' + need + ' lb/day · ' + (state.form || '') + ' ice · ' + (state.config || '') + '. Prices include freight.';
      var html = '';
      matches.forEach(function(md, i){
        html += '<div class="hb-collection-v2-result-card' + (i === 0 ? ' best' : '') + '">'
          + (i === 0 ? '<span class="hb-collection-v2-result-badge">Best match</span>' : '')
          + '<div class="hb-collection-v2-result-img"><img src="' + md.img + '" alt="Manitowoc ' + md.m + ' commercial ice machine" loading="lazy" width="240" height="240"></div>'
          + '<div><span class="hb-collection-v2-result-series">' + md.series + '</span><h4 class="hb-collection-v2-result-model">Manitowoc ' + md.m + '</h4></div>'
          + '<div class="hb-collection-v2-result-specs">'
          + '<span>Production <b>' + md.lbday + ' lb/day</b></span>'
          + '<span>Storage <b>' + (md.bin ? md.bin + ' lb' : '—') + '</b></span>'
          + '<span>Width <b>' + md.width + '</b></span>'
          + '<span>Power <b>' + md.volt + '</b></span>'
          + '</div>'
          + '<div style="display:flex;align-items:baseline;gap:8px;flex-wrap:wrap"><span class="hb-collection-v2-result-price">$' + md.price.toLocaleString() + '</span>' + WEBPRICE_HTML + '<span class="hb-collection-v2-result-stock">✓ In stock · Free freight</span></div>'
          + '<div class="hb-collection-v2-result-ctas">'
          + '<a href="/products/' + md.handle + '" class="hb-collection-v2-btn-primary" data-ga4="picker_result_view_product" data-model="' + md.m + '">View machine</a>'
          + '<button type="button" class="hb-collection-v2-btn-secondary" data-open-quote data-ga4="picker_result_quote" data-model="' + md.m + '">Get a quote</button>'
          + '</div></div>';
      });
      $('result-cards').innerHTML = html;
      fireGA4Event('picker_result', {ice_form: state.form, config: state.config, lbday: need});
      window.hbQuoteContext = {
        page: location.pathname,
        picker: { business: state.biz, size: state.size, lbday: need, ice_form: state.form, config: state.config, volt: state.volt },
        matches: matches.map(function(md){ return md.m; })
      };
      var sc = $('sticky-cta');
      if (sc) { sc.textContent = 'Your matches ↑'; }
      bindAnchors($('result-cards'));
      $('result-cards').querySelectorAll('[data-ga4]').forEach(function(el){
        el.addEventListener('click', function(){ fireGA4Event(el.dataset.ga4, {model: el.dataset.model}); });
      });
    };

    $('picker-back').addEventListener('click', function(){ if (stepIdx > 0) { stepIdx--; renderStep(); } });
    $('picker-restart').addEventListener('click', function(){
      state = {}; stepIdx = 0; started = false;
      $('picker-results').classList.remove('show');
      stepsEl.style.display = '';
      var sc = $('sticky-cta');
      if (sc) { sc.textContent = 'Find my ice machine →'; }
      renderStep();
    });
    renderStep();
  }

  /* ---------- FAQ accordion ---------- */
  root.querySelectorAll('.hb-collection-v2-acc-trigger').forEach(function(btn){
    btn.addEventListener('click', function(){
      var item = btn.closest('.hb-collection-v2-acc-item');
      var body = item.querySelector('.hb-collection-v2-acc-body');
      var open = item.classList.toggle('open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      body.hidden = !open;
    });
  });

  /* ---------- sticky mobile bar ---------- */
  var hero = $('hero-primary-cta'), bar = $('sticky-bar'), picker = $('picker');
  if ('IntersectionObserver' in window && hero && bar && picker) {
    var heroVisible = true, pickerVisible = false;
    var update = function(){ bar.classList.toggle('is-visible', !heroVisible && !pickerVisible); };
    new IntersectionObserver(function(e){ heroVisible = e[0].isIntersecting; update(); }, {rootMargin: '0px'}).observe(hero);
    new IntersectionObserver(function(e){ pickerVisible = e[0].isIntersecting; update(); }, {rootMargin: '-80px 0px 0px 0px'}).observe(picker);
  }

  /* ---------- capture form (Klaviyo client API; goes live when list ID is set in theme editor) ---------- */
  var capForm = $('capture-form');
  if (capForm) {
    capForm.addEventListener('submit', function(ev){
      ev.preventDefault();
      var email = capForm.querySelector('input[type="email"]').value.trim();
      if (!email) return;
      var companyId = capForm.dataset.klaviyoCompanyId, listId = capForm.dataset.klaviyoListId;
      var done = function(msg){
        capForm.style.display = 'none';
        var s = $('capture-success');
        s.textContent = msg;
        s.classList.add('show');
      };
      fireGA4Event('hub_capture_submit');
      if (companyId && listId) {
        fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(companyId), {
          method: 'POST',
          headers: {'Content-Type': 'application/json', 'revision': '2024-10-15'},
          body: JSON.stringify({data: {type: 'subscription', attributes: {custom_source: 'manitowoc-hub', profile: {data: {type: 'profile', attributes: {email: email}}}}, relationships: {list: {data: {type: 'list', id: listId}}}}})
        }).then(function(r){
          done(r.status === 202 ? '✓ Check your inbox — the guide is on its way.' : 'Something went wrong — email help@howdybrewer.com and we’ll send it directly.');
        }).catch(function(){
          done('Something went wrong — email help@howdybrewer.com and we’ll send it directly.');
        });
      } else {
        done('Guide delivery goes live shortly — email help@howdybrewer.com and we’ll send it to you today.');
      }
    });
  }

  /* ---------- Web Price tooltips (tap support — iOS doesn't focus buttons on tap) ---------- */
  function closeWebprices(except){
    document.querySelectorAll('.hb-collection-v2-webprice.open').forEach(function(w){
      if (w !== except) w.classList.remove('open');
    });
  }
  function flipWebprice(w){
    var r = w.getBoundingClientRect();
    w.classList.toggle('flip', r.left + 280 > window.innerWidth);
  }
  document.addEventListener('mouseover', function(e){
    var w = e.target.closest('.hb-collection-v2-webprice');
    if (w) flipWebprice(w);
  });
  document.addEventListener('click', function(e){
    var q = e.target.closest('.hb-collection-v2-webprice-q');
    if (q) {
      e.preventDefault();
      e.stopPropagation();
      var w = q.closest('.hb-collection-v2-webprice');
      var opening = !w.classList.contains('open');
      closeWebprices(w);
      flipWebprice(w);
      w.classList.toggle('open');
      if (opening) fireGA4Event('hub_webprice_open');
      return;
    }
    if (e.target.closest('[data-open-quote]')) {
      closeWebprices();
      return; /* let the global quote-drawer handler take it */
    }
    if (!e.target.closest('.hb-collection-v2-webprice')) closeWebprices();
  });

  /* ---------- GA4 on static CTAs ---------- */
  root.querySelectorAll('[data-ga4-static]').forEach(function(el){
    el.addEventListener('click', function(){
      fireGA4Event(el.dataset.ga4Static, el.dataset.handle ? {handle: el.dataset.handle, position: el.dataset.position} : {});
    });
  });

  /* ---------- smooth scroll for in-page anchors ---------- */
  function bindAnchors(scope){
    (scope || root).querySelectorAll('a[href^="#"]').forEach(function(a){
      if (a.dataset.bound) return;
      a.dataset.bound = '1';
      a.addEventListener('click', function(ev){
        var id = a.getAttribute('href');
        if (id.length < 2) return;
        var t = document.getElementById(id.slice(1));
        if (t) { ev.preventDefault(); t.scrollIntoView({behavior: 'smooth'}); }
      });
    });
  }
  bindAnchors();
  var sticky = $('sticky-bar');
  if (sticky) bindAnchors(sticky);
})();


/* ---------- in-page category filter (tag-based, AJAX-enhanced; no-JS falls back to full nav) ---------- */
(function(){
  var chips = document.getElementById('hub-filter-chips');
  var block = document.getElementById('hub-grid-block');
  if (!chips || !block) return;
  function setLoading(on){ block.style.opacity = on ? '.4' : ''; block.style.pointerEvents = on ? 'none' : ''; }
  function load(url, push){
    setLoading(true);
    fetch(url, { headers: { 'X-Requested-With': 'fetch' } })
      .then(function(r){ return r.text(); })
      .then(function(html){
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nb = doc.getElementById('hub-grid-block');
        var nc = doc.getElementById('hub-filter-chips');
        if (nb) block.innerHTML = nb.innerHTML;
        if (nc) chips.innerHTML = nc.innerHTML;
        if (push) history.pushState({ hubFilter: 1 }, '', url);
        setLoading(false);
        var anchor = document.getElementById('all-models');
        if (anchor) { window.scrollTo({ top: anchor.getBoundingClientRect().top + window.pageYOffset - 80, behavior: 'smooth' }); }
      })
      .catch(function(){ window.location.href = url; });
  }
  function go(e){
    var a = e.target.closest('a');
    if (!a || !a.getAttribute('href')) return;
    e.preventDefault();
    load(a.href, true);
  }
  chips.addEventListener('click', go);
  block.addEventListener('click', function(e){ if (e.target.closest('.hb-collection-v2-pagination')) go(e); });
  window.addEventListener('popstate', function(){ load(location.href, false); });
})();
